export enum PromotionCategory {
    SponsoredContent = 0,
    PromotedClass,
}
